var HeadingType;
(function (HeadingType) {
    HeadingType["CONTEXTUAL_BAR"] = "contextual-bar";
    HeadingType["SECTION"] = "section";
    HeadingType["SUBSECTION"] = "subsection";
})(HeadingType || (HeadingType = {}));
export { HeadingType, };
//# sourceMappingURL=heading-constants.js.map